import exportForInvoices from './export';
import allInvoices from './get-all';

export default {
	exportForInvoices,
	allInvoices,
};
